import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';


const getMetaTags = ({
                         title, description,contentType,url,keywords, tags, imgUrl,
                     }) => {
    const metaTags = [
        { itemprop: 'name', content: title },
        { itemprop: 'description', content: description },
        { itemprop: 'image', content: imgUrl },
        { name: 'description', content: description },
        // { name: 'twitter:card', content: 'summary_large_image' },
        // { name: 'twitter:site', content: '@themeteorchef' },
        // { name: 'twitter:title', content: `${title} | The Meteor Chef` },
        // { name: 'twitter:description', content: description },
        // { name: 'twitter:creator', content: twitter || '@themeteorchef' },
        // { name: 'twitter:image:src', content: seoImageURL(_.sample(seoImages.twitter)) },
        { name: 'keywords', content: `${keywords} | Mordor Intelligence` },
        { name: 'og:title', content: `${title} | Mordor Intelligence` },
        { name: 'og:type', content: contentType },
        { name: 'og:url', content: url },
        { name: 'og:image', content: "https://mordorintelligence.com:81/images/mordor_logo.png" },
        { name: 'og:description', content: description },
        { name: 'og:site_name', content: 'Mordor Intelligence' },
        { name: 'fb:app_id', content: '<FB App ID>' },
    ];

    // if (published) metaTags.push({ name: 'article:published_time', content: published });
    // if (updated) metaTags.push({ name: 'article:modified_time', content: updated });
    // if (category) metaTags.push({ name: 'article:section', content: category });
    if (tags) metaTags.push({ name: 'article:tag', content: tags });

    return metaTags;
};

// const seoURL = path => Meteor.absoluteUrl(path);

const SEO = ({
                 schema, title, description,keywords, path, contentType, published, updated, category, tags, twitter,
             }) => (

    <Helmet defer={false}
        htmlAttributes={{
            lang: 'en',
            itemscope: undefined,
            itemtype: `http://schema.org/${schema}`,
        }}
        title={ title }
        link={[
            { rel: 'canonical', href: path },
        ]}
        meta={getMetaTags({
            title,
            description,
            contentType,
            url: path,
            keywords
        })}
    />
);

SEO.propTypes = {
    schema: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    path: PropTypes.string
};

export default SEO;


// WEBPACK FOOTER //
// ./src/SEO/seo.js